import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker, DatePickerProps } from '@sato/components';

export const HookFormDatePicker = (
  props: { name: string } & DatePickerProps
) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <DatePicker
          {...props}
          {...field}
          onChange={(value) => field.onChange(value)}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
